/* eslint-disable indent */
/* eslint-disable no-underscore-dangle */
import React, {useEffect, useState} from 'react';

import {ReactComponent as CheckIcon} from 'assets/svgs/actions/confirm-delete-check.svg';
import {searchDocuments} from 'utils/fetch';
import LoadingIndicator from 'components/LoadingIndicator';
import useClickPreventionOnDoubleClick from 'hooks/useDoubleClick';
import {useDispatch} from 'react-redux';
import {moveFolder} from 'actions/documentsActions';
import {getFileIcon} from 'utils/commonReact';
import BreadCrumb from './Breadcrumb';

const MoveExisting = ({
  searchKey,
  userDetails,
  setSearchKey,
  selectedFolder,
  onClose,
}) => {
  const dispatch = useDispatch();

  const [selected, setSelected] = useState(null);
  const [inside, setInside] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const [folders, setFolders] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState();
  const [file, setHovered] = useState(null);
  console.log(selected, 'selected');
  const onClick = () => {
    setSelected(file);
  };

  const onDoubleClick = () => {
    setSearchKey('');
    const newBreadCrumb = [...breadcrumb];
    newBreadCrumb.push(file);
    setBreadcrumb(newBreadCrumb);
    setInside(file);
    setSelected(null);
    setFolders([]);
    setTimeout(() => {
      setLoad(Math.random());
      setHovered(null);
    }, 100);
  };

  const [handleClick, handleDoubleClick] = useClickPreventionOnDoubleClick(
    onClick,
    onDoubleClick
  );

  const getFolders = async () => {
    setLoading(true);

    const params = {
      searchKey,
    };

    if (inside) {
      params.folderId = inside._id;
    }

    const list = await searchDocuments({
      authToken: userDetails.authToken,
      filters: params,
      companyId: null,
    });

    setFolders(list);
    setLoading(false);
  };

  useEffect(() => {
    if (!selectedTab) {
      setBreadcrumb([]);
    }
  }, [selectedTab]);

  useEffect(() => {
    getFolders();
  }, [load, searchKey]);

  const loadFolders = () => {
    if (loading) {
      return <LoadingIndicator />;
    }
    return folders
      .filter((f) => f.folderType !== 'FILE')
      .map((tab, index) => (
        <div
          aria-hidden
          key={tab._id}
          onMouseEnter={() => setHovered(tab)}
          onClick={handleClick}
          onDoubleClick={handleDoubleClick}
          className={`d-flex px-4 pointer align-items-center ${
            selected && selected._id === tab._id ? 'bg-gold' : ''
          } py-2 ${index + 1 === folders.length ? '' : 'border-bottom'}`}
        >
          {getFileIcon(tab)} {tab.name}
        </div>
      ));
  };
  return (
    <div className="d-flex move-existing flex-column">
      <div className="header d-flex border-bottom px-3 align-items-center">
        <BreadCrumb
          tab={selectedTab ? selectedTab.name : ''}
          list={breadcrumb}
          onClick={(folder) => {
            if (!folder) {
              setSelectedTab(null);
              setFolders([]);
              setSelected([]);
              setInside(null);
            } else {
              const newBreadCrumm = [];
              breadcrumb.every((f) => {
                if (f._id !== folder._id) {
                  newBreadCrumm.push(f);
                  return true;
                }
                newBreadCrumm.push(f);
                return false;
              });

              setBreadcrumb(newBreadCrumm);
              setInside(folder);
            }
          }}
          setSelectedTab={() => {
            setSelectedTab(null);
            setFolders([]);
            setSelected([]);
            setInside(null);
          }}
        />
      </div>

      <div className="d-flex flex-column border-bottom move-body">
        {loadFolders()}
      </div>

      <div className="d-flex move-footer px-3 justify-content-between align-items-center">
        <span>Move file/folder to selected folder</span>
        <button
          type="button"
          className="cat-delete"
          disabled={!selected}
          onClick={() => {
            let moveSelected = null;
            if (selected) moveSelected = selected._id;
            if (inside) moveSelected = inside._id;

            dispatch(moveFolder(selectedFolder._id, moveSelected, 'DOCUMENT'));

            onClose();
          }}
        >
          <CheckIcon className="mr-2" />
          Confirm
        </button>
      </div>
    </div>
  );
};

export default MoveExisting;
